import AppDetails from './AppDetails';
import Compliance from './Compliance';
import ContactDetails from './ContactDetails';
import Readiness from './Readiness';
import TestAccount from './TestAccount';

export default {
  AppDetails,
  Compliance,
  ContactDetails,
  Readiness,
  TestAccount,
};
